import styled from 'styled-components';

export const StyledTaskActivityNav = styled.div`
  overflow-y: auto;
  flex: 1;
  width: 100%;

  .task-activity-links {
    display: flex;
    flex-direction: column;
    position: relative;
  }
`;
